module.exports = __webpack_public_path__ + "static/media/Keo Pich Headshot.72988cd0.jpeg";